export type Role = "worker" | "approver" | "super_admin";
export type BanReason = "DEACTIVATED" | "ARCHIVED";

export interface UserSaveBefore {
  name: string;
  role: Role;
  defaultApproverId: string | null;
  erpEmployeeNumber: string | null;
  isActive: boolean;
}

export interface UserSaveAfter {
  name: string;
  role: Role;
  defaultApproverId: string | null;
  erpEmployeeNumber: string | null;
  isActive: boolean;
  roleChangeReason: string;
  banReason: BanReason;
}

export type SaveStep =
  | { op: "update"; body: { name: string; defaultApproverId: string | null } }
  | { op: "setRole"; body: { role: Role; reason: string } }
  | { op: "linkErp"; body: { erpEmployeeNumber: string } }
  | { op: "ban"; body: { reason: BanReason } }
  | { op: "unban" };

function normaliseErp(v: string | null): string {
  return v ?? "";
}

export function planUserSave(before: UserSaveBefore, after: UserSaveAfter): SaveStep[] {
  const steps: SaveStep[] = [];

  if (before.name !== after.name || before.defaultApproverId !== after.defaultApproverId) {
    steps.push({
      op: "update",
      body: { name: after.name, defaultApproverId: after.defaultApproverId },
    });
  }

  if (before.role !== after.role) {
    steps.push({ op: "setRole", body: { role: after.role, reason: after.roleChangeReason } });
  }

  if (normaliseErp(before.erpEmployeeNumber) !== normaliseErp(after.erpEmployeeNumber)) {
    // API treats empty string as missing; normalise on the way out.
    steps.push({ op: "linkErp", body: { erpEmployeeNumber: after.erpEmployeeNumber ?? "" } });
  }

  if (before.isActive !== after.isActive) {
    steps.push(after.isActive ? { op: "unban" } : { op: "ban", body: { reason: after.banReason } });
  }

  return steps;
}
